export default "__VITE_ASSET__3b9194b8__"